<template>
    <div class="loading">
        <div class='loadingWrap'>
            <div class="sk-wandering-cubes mb20">
                <div class="sk-cube sk-cube1"></div>
                <div class="sk-cube sk-cube2"></div>
                <div class="sk-cube sk-cube3"></div>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped>
    .loading {
        width:100%;
        height:100%;
        position: fixed;
        top: 0;
        left: 0;
        /* background-color: rgba(0,0,0,0.5); */
        z-index: 999999;
    }
    .loadingWrap{
        width:110px;
        padding:15px 5px;
        border-radius: 5px;
        background-color: rgba(0,0,0,.5);
        overflow: hidden;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        -webkit-transform:translate(-50%,-50%);
        color:white;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        font-size: 15px;
    }
    .sk-wandering-cubes {
        width: 60px;
        height: 60px;
        margin:0 auto;
        position: relative;
    }
    .mb20{
        margin-bottom: 10px!important;
    }
    .sk-wandering-cubes .sk-cube {
        background-color: white;
        width: 15px;
        height: 15px;
        position: absolute;
        top: 0;
        left: 0;
        -webkit-animation: sk-wanderingCube 1.8s ease-in-out -1.8s infinite both;
        animation: sk-wanderingCube 1.8s ease-in-out -1.8s infinite both;
    }

    .sk-wandering-cubes .sk-cube2 {
        -webkit-animation-delay: -0.6s;
        animation-delay: -0.6s;
    }

    .sk-wandering-cubes .sk-cube3 {
        -webkit-animation-delay: -1.2s;
        animation-delay: -1.2s;
    }

    @-webkit-keyframes sk-wanderingCube {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        25% {
            -webkit-transform: translateX(45px) rotate(-90deg) scale(0.5);
            transform: translateX(45px) rotate(-90deg) scale(0.5);
        }

        50% {
            /* Hack to make FF rotate in the right direction */
            -webkit-transform: translateX(45px) translateY(45px) rotate(-179deg);
            transform: translateX(45px) translateY(45px) rotate(-179deg);
        }

        50.1% {
            -webkit-transform: translateX(45px) translateY(45px) rotate(-180deg);
            transform: translateX(45px) translateY(45px) rotate(-180deg);
        }

        75% {
            -webkit-transform: translateX(0) translateY(45px) rotate(-270deg) scale(0.5);
            transform: translateX(0) translateY(45px) rotate(-270deg) scale(0.5);
        }

        100% {
            -webkit-transform: rotate(-360deg);
            transform: rotate(-360deg);
        }
        }

        @keyframes sk-wanderingCube {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        25% {
            -webkit-transform: translateX(45px) rotate(-90deg) scale(0.5);
            transform: translateX(45px) rotate(-90deg) scale(0.5);
        }

        50% {
            /* Hack to make FF rotate in the right direction */
            -webkit-transform: translateX(45px) translateY(45px) rotate(-179deg);
            transform: translateX(45px) translateY(45px) rotate(-179deg);
        }

        50.1% {
            -webkit-transform: translateX(45px) translateY(45px) rotate(-180deg);
            transform: translateX(45px) translateY(45px) rotate(-180deg);
        }

        75% {
            -webkit-transform: translateX(0) translateY(45px) rotate(-270deg) scale(0.5);
            transform: translateX(0) translateY(45px) rotate(-270deg) scale(0.5);
        }

        100% {
            -webkit-transform: rotate(-360deg);
            transform: rotate(-360deg);
        }
    }
</style>


